module.exports = __webpack_public_path__ + "static/media/home.210181bc.png";